import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http.service';
import { Employee } from './employee.modal';
import { Observable } from 'rxjs';
import { GetItemsParams } from '../../attorney/service/attorney.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private apiService: HttpService) {}

  AddEmployee(data: Employee): Observable<any> {
    return this.apiService.postData('Employee', data);
  }

  GetEmployees(param: GetItemsParams): Observable<any> {
    let params = this.apiService.Params;
    params = params.set('searchValue', param.searchValue);
    params = params.set('skip', param.skip);
    params = params.set('take', param.take);
    params = params.set('sortColumn', param.sortColumn);
    params = params.set('sortOrder', param.sortOrder);
    params = params.set('clinicId', param.clinicId ? param.clinicId : 0);
    return this.apiService.getData<Employee>(`Employee`, params);
  }

  GetEmployee(id: number): Observable<any> {
    return this.apiService.getData<Employee>(`Employee/${id}`);
  }

  UpdateEmployee(data: Employee): Observable<any> {
    return this.apiService.putData<Employee>(`Employee/${data.userId}`, data);
  }

  DeleteEmployee(id: number): Observable<any> {
    return this.apiService.deleteData<Employee>(`Employee/${id}`);
  }

  ChangePassword(passwords: Partial<{ newPassword: string; oldPassword: string }>): Observable<any> {
    return this.apiService.postData<Partial<{ newPassword: string; oldPassword: string }>>(`Authenticate/ChangePassword`, passwords);
  }
}
